import ResultadosClinicos from "./ResultadosClinicos";
import CondicionesMedicasAdicionales from "./CondicionesMedicasAdicionales";
import LineaDeTiempo from "./LineaDeTiempo";
import Eventos from "./Eventos";
import Medicamentos from "./Medicamentos";
import Sintomas from "./Sintomas";
const DatosClinicos = () => {
  return (
    <div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <LineaDeTiempo />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <ResultadosClinicos />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <CondicionesMedicasAdicionales />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <Medicamentos />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <Sintomas />
        </div>
      </div>
    </div>
  );
};

export default DatosClinicos;
